/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { OrganisationRoleFromJSON, OrganisationRoleToJSON, } from './OrganisationRole';
/**
 * Check if a given object implements the OrganisationResponse interface.
 */
export function instanceOfOrganisationResponse(value) {
    var isInstance = true;
    return isInstance;
}
export function OrganisationResponseFromJSON(json) {
    return OrganisationResponseFromJSONTyped(json, false);
}
export function OrganisationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'organisationRoles': !exists(json, 'organisationRoles') ? undefined : (json['organisationRoles'].map(OrganisationRoleFromJSON)),
        'active': !exists(json, 'active') ? undefined : json['active'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData'])
    };
}
export function OrganisationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'organisationRoles': value.organisationRoles === undefined ? undefined : (value.organisationRoles.map(OrganisationRoleToJSON)),
        'active': value.active,
        'metaData': MetaDataToJSON(value.metaData)
    };
}
